import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  transition: transform ", " ease-in-out;\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n      & > ", " {\n        ", "\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n      &:hover,\n      &:active,\n      &:focus {\n        & > ", " {\n          ", "\n        }\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n      & > ", " {\n        background-color: ", ";\n        ", "\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  outline: none;\n  border: none;\n  position: absolute;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  margin: 0;\n  padding: 0;\n  background-color: transparent;\n\n  ", "\n  ", "\n  \n  ", "\n  ", "\n  ", "\n  \n  cursor: ", ";\n\n  & > ", " {\n    ", "\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  border-radius: 50%;\n  background-color: ", ";\n  opacity: 1;\n  transition: width 0.2s ease-in-out, height 0.2s ease-in-out, background-color 0.2s ease-in-out,\n    opacity 0.2s ease-in-out;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 0;\n  height: 0;\n  position: relative;\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  overflow: hidden;\n  transform: translate3d(0, 0, 0); // Workaround for iOS safari bug\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import Flex from '../../../Flex';
import { ADVENTURE_GREEN, LINE_GRAY } from '../../../colors';
import { getMs, getPx } from '../../../helpers/common';
import { prevent } from '../../../helpers';
import { userSelectNoneStyle } from '../../../tokens/user-select';
import { styleForBreakpoints } from '../../../helpers/media-style';
import { baseHighlightStyle } from '../../../tokens/highlight';
import { size } from '../../../style/size';
import { leftHalfNegative } from '../../../style/left-negative';
import { topHalfNegative } from '../../../style/top-negative';
import { paddingHalf } from '../../../style/padding';
import { marginHalfNegative } from '../../../style/margin-negative';
import { marginRight } from '../../../style/margin-right';
var CAROUSEL_DOTS_DISTANCE_BETWEEN = {
  xs: 16,
  md: 24
};
var CAROUSEL_DOTS_SIZE_SMALL = {
  xs: 4,
  md: 6
};
var CAROUSEL_DOTS_SIZE_NORMAL = {
  xs: 6,
  md: 8
};
var CAROUSEL_DOTS_SIZE_LARGE = {
  xs: 8,
  md: 12
};
var WrapperInner = styled.div(_templateObject(), function (_ref) {
  var $dotsAmount = _ref.$dotsAmount,
      $itemsAmount = _ref.$itemsAmount;
  return styleForBreakpoints(CAROUSEL_DOTS_DISTANCE_BETWEEN, function ($distanceBetween) {
    return "width: " + getPx((Math.min($dotsAmount, $itemsAmount) - 1) * $distanceBetween) + ";";
  });
});
var WrapperOuter = styled.div(_templateObject2(), paddingHalf(CAROUSEL_DOTS_DISTANCE_BETWEEN), marginHalfNegative(CAROUSEL_DOTS_DISTANCE_BETWEEN));
var DotPlaceholder = styled.div(_templateObject3(), marginRight(CAROUSEL_DOTS_DISTANCE_BETWEEN));
var Dot = styled.div(_templateObject4(), LINE_GRAY);
var DotButton = styled.button(_templateObject5(), leftHalfNegative(CAROUSEL_DOTS_DISTANCE_BETWEEN), topHalfNegative(CAROUSEL_DOTS_DISTANCE_BETWEEN), size(CAROUSEL_DOTS_DISTANCE_BETWEEN), baseHighlightStyle, userSelectNoneStyle, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'default' : 'pointer';
}, Dot, size(CAROUSEL_DOTS_SIZE_NORMAL), function (_ref3) {
  var $active = _ref3.$active;
  return $active && css(_templateObject6(), Dot, ADVENTURE_GREEN, size(CAROUSEL_DOTS_SIZE_LARGE));
}, function (_ref4) {
  var $active = _ref4.$active,
      disabled = _ref4.disabled;
  return !$active && !disabled && css(_templateObject7(), Dot, size(CAROUSEL_DOTS_SIZE_LARGE));
}, function (_ref5) {
  var $small = _ref5.$small;
  return $small && css(_templateObject8(), Dot, size(CAROUSEL_DOTS_SIZE_SMALL));
}, function (_ref6) {
  var $transparent = _ref6.$transparent;
  return $transparent && "\n    & > " + Dot + " {\n      opacity: 0;\n    }\n  ";
});
var StyledFlex = styled(Flex)(_templateObject9(), function (_ref7) {
  var $scrollAmount = _ref7.$scrollAmount;
  return getMs(Math.max(Math.min($scrollAmount, 2), 1) * 200);
}, function (_ref8) {
  var $index = _ref8.$index;
  return styleForBreakpoints(CAROUSEL_DOTS_DISTANCE_BETWEEN, function ($distanceBetween) {
    return "transform: translate(-" + getPx($index * $distanceBetween) + ", 0);";
  });
});

var _ref10 = /*#__PURE__*/React.createElement(Dot, null);

var ItemsCarouselDots = function ItemsCarouselDots(_ref9) {
  var previousActiveItemIndex = _ref9.previousActiveItemIndex,
      activeItemIndex = _ref9.activeItemIndex,
      itemsAmount = _ref9.itemsAmount,
      dotsAmount = _ref9.dotsAmount,
      onChange = _ref9.onChange,
      _ref9$disableChange = _ref9.disableChange,
      disableChange = _ref9$disableChange === void 0 ? false : _ref9$disableChange,
      _ref9$getDotLabel = _ref9.getDotLabel,
      getDotLabel = _ref9$getDotLabel === void 0 ? function (index, count) {
    return "Move to " + (index + 1) + " out of " + count;
  } : _ref9$getDotLabel,
      _ref9$getDotProps = _ref9.getDotProps,
      getDotProps = _ref9$getDotProps === void 0 ? function () {
    return {};
  } : _ref9$getDotProps,
      props = _objectWithoutPropertiesLoose(_ref9, ["previousActiveItemIndex", "activeItemIndex", "itemsAmount", "dotsAmount", "onChange", "disableChange", "getDotLabel", "getDotProps"]);

  var translateRightIndex = useMemo(function () {
    return Math.max(activeItemIndex - Math.ceil((dotsAmount - 1) / 2), 0);
  }, [activeItemIndex, dotsAmount]);
  var translateLeftIndex = useMemo(function () {
    return Math.max(activeItemIndex - Math.floor((dotsAmount - 1) / 2), 0);
  }, [activeItemIndex, dotsAmount]);
  var direction = useMemo(function () {
    return activeItemIndex > previousActiveItemIndex ? 'right' : 'left';
  }, [activeItemIndex, previousActiveItemIndex]);
  var translateIndex = useMemo(function () {
    return Math.min(direction === 'right' ? translateRightIndex : translateLeftIndex, Math.max(itemsAmount - dotsAmount, 0));
  }, [direction, translateRightIndex, translateLeftIndex, itemsAmount, dotsAmount]);
  return /*#__PURE__*/React.createElement(WrapperOuter, props, /*#__PURE__*/React.createElement(WrapperInner, {
    $dotsAmount: dotsAmount,
    $itemsAmount: itemsAmount
  }, /*#__PURE__*/React.createElement(StyledFlex, {
    direction: 'ltr',
    alignItems: 'center',
    $index: translateIndex,
    $scrollAmount: Math.abs(activeItemIndex - (previousActiveItemIndex != null ? previousActiveItemIndex : activeItemIndex))
  }, Array(itemsAmount).fill(undefined).map(function (u, index) {
    return /*#__PURE__*/React.createElement(DotPlaceholder, {
      key: index
    }, /*#__PURE__*/React.createElement(DotButton, _extends({
      role: "button",
      "aria-label": getDotLabel(index, itemsAmount),
      disabled: disableChange || index === activeItemIndex,
      $active: index === activeItemIndex,
      onClick: function onClick(e) {
        prevent(e);
        onChange == null ? void 0 : onChange(index);
      },
      $small: index > 0 && index <= translateIndex || index < itemsAmount - 1 && index >= translateIndex + dotsAmount - 1,
      $transparent: index < translateIndex || index > translateIndex + dotsAmount - 1
    }, getDotProps(index, itemsAmount)), _ref10));
  }))));
};

export default ItemsCarouselDots;